import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';
import * as _ from 'lodash';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-text-input-element',
  templateUrl: './text-input-element.component.html',
  styleUrls: ['./text-input-element.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class TextInputElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;
  @Input() formValues: any | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  public getControlName(): string {
    return 'input' + this.getName();
  }

  public getName(): string {
    return this.element?.name ?? '';
  }

  public getLabel(): string {
    return this.element?.label ?? '';
  }

  public getPattern(): string {
    return this.element?.pattern ?? '';
  }

  public getPlaceholder(): string {
    return this.element?.placeholder ?? '';
  }

  public isLabelVisible(): boolean {
    return this.getLabel() !== '' && this.isControlVisible();
  }

  public isControlVisible(): boolean {
    return !_.isNil(this.element) && !_.isNil(this.formValues);
  }

  public isRequired(): boolean {
    return this.element?.required ?? false;
  }
}
